import { NgModule } from '@angular/core';

import { LIB_CommonModule } from "pbc.angular";

import { FormularService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [
    FormularService,
  ],
  exports: []
})
export class FormularServiceModule { }
